import { Header } from 'antd/es/layout/layout'
import React, { useEffect, useState } from 'react'
import {MenuOutlined, CloseOutlined,DownOutlined,UpOutlined,ShoppingOutlined} from '@ant-design/icons';
import smallLogo from 'assets/images/black-logo.png';
import whiteLogo from 'assets/images/white-logo.png';
import { useNavigate } from 'react-router-dom';
import { Awning, Blinds, Curtains, Plantations, RollerShutters } from './ProductCollection';
import { useAuth } from 'hooks';
import { getCurrUserDetailByUserId, User } from 'services/UserServices';
import { AxiosError } from 'axios';
import { useAuthModalStore, useNewOrderStore } from 'modules/zustand/store';
import { Badge } from 'antd';


const productCategoryStyle = "flex flex-col border-l-0 border-r-0 border-t-0 border-b border-solid border-black w-full h-fit "
const userDropdownStyle = "flex flex-col w-full h-fit "
const productCategoryTextStyle = "font-[450] text-xl hover:underline hover:translate-x-1 duration-300 transition-transform"
const choicesStyle = "font-medium text-base hover:underline hover:translate-x-1 duration-300 transition-transform"

export default function SmallHeaderSticky() {
    const [horizontalMenuDisplay, setHorizontalMenuDisplay] = useState(false)
    const [blindDropDown, setBlindDropDown] = useState(false)
    const [awningDropDown, setAwningDropDown] = useState(false)
    const [curtainDropDown, setCurtainDropDown] = useState(false)
    const [PShutterDropDown, setPShutterDropDown] = useState(false)
    const [RShutterDropDown, setRShutterDropDown] = useState(false)
    const navigate = useNavigate()
    const closeAllDropDown = ()=>{
        setHorizontalMenuDisplay(!horizontalMenuDisplay)
        setBlindDropDown(false)
        setAwningDropDown(false)
        setCurtainDropDown(false)
        setPShutterDropDown(false)
        setRShutterDropDown(false)
    }
    const setOnLoginModal = useAuthModalStore((state)=>state.setOnLoginModal)
    const { logout } = useAuth();
    const [currUser, setCurrUser] = useState<User>(); 

    const fetchCurrUser = async () => {
        try {
        const data = await getCurrUserDetailByUserId();
        setCurrUser(data)
        } catch (err: any) {
            const error = err as AxiosError;
            console.log(error)
            console.log(currUser)
    }
    };
    useEffect(() => {
        fetchCurrUser();
    }, [])

    const get_menu_horizontal = ( ) =>{
        if (Number(currUser?.role_id) != 1 && Number(currUser?.role_id) != 2){
            return true
        }   
        else{
            return false
        }
    }
    const totalPrice = useNewOrderStore((state)=> state.totalPrice)
    return (
        <div
            className='absolute border-none flex items-center  w-full top-0 z-50 flex flex-col bg-white h-fit lg:hidden px-2 py-3'
        >
                <div className='w-full flex justify-between items-center  max-w-screen-2xl m-auto mb-3 mt-3'>
                    
                    <div className="flex m-1 flex-row items-center gap-3" style={{height:'40px'}}>
                        <div 
                                className={`flex justify-center items-center rounded-md hover:-translate-y-1 duration-300 transition-transform hover:bg-neutral-300  overflow-hidden`} 
                                style={{width:'40px',height:'40px'}} 
                                onClick={()=>{
                                    closeAllDropDown()
                                }}>
                                {(horizontalMenuDisplay)&&<CloseOutlined style={{ fontSize: '20px'}}/>}
                                {!(horizontalMenuDisplay)&&<MenuOutlined style={{ fontSize: '20px'}}/>}
                            </div>
                    

                    </div>
                    <div className="flex mt-2" onClick={()=>{navigate('/')}}>
                    <img className="m-auto" style={{maxHeight:'40px'}} src={smallLogo} />
                    </div>
                    
                    <div className={`flex justify-center items-center rounded-md hover:-translate-y-1 duration-300 transition-transform hover:bg-neutral-300`} style={{width:'40px',height:'40px'}}
                        onClick={()=>{navigate('/order/create')}}
                    >
                        <Badge dot ={(Number(totalPrice)!=0)} className={` transition-all duration-300  `}>
                            <ShoppingOutlined style={{ fontSize: '20px'}}></ShoppingOutlined>
                        </Badge>
                    </div>
                    
                </div>  
                <div className={`px-2 w-full flex flex-col gap-3 max-w-screen-2xl m-auto mb-2 transition-height  overflow-hidden ${horizontalMenuDisplay ? 'h-[30rem]' : 'h-0'} transition-all duration-500 ease-in-out overflow-scroll`}>
                    
                    <div className={productCategoryStyle}>
                        <div className='w-full flex flex-row justify-between '>
                            <span className={productCategoryTextStyle}
                                onClick={()=>{
                                navigate('/products/awnings')
                                closeAllDropDown()
                                }}
                            >
                                Awnings
                            </span>
                            <div 
                                    className='flex justify-center items-center rounded-md' 
                                    
                                    onClick={()=>{
                                    setAwningDropDown(!awningDropDown)
                            }}>
                                    {(awningDropDown)&&<UpOutlined style={{ fontSize: '20px'}}/>}
                                    {!(awningDropDown)&&<DownOutlined style={{ fontSize: '20px'}}/>}
                            
                            </div>
                        </div>
                        
                        <div className={`mt-2 w-full flex flex-col gap-3 max-w-screen-2xl m-auto transition-height overflow-hidden ${awningDropDown ? 'h-[14em]' : 'h-0'} transition-all duration-500 ease-in-out pl-3`}>
                        
                            {Awning.map((item,index)=>{
                                        return(<span key={index} className={choicesStyle}
                                            onClick={()=>{navigate(item.page)}}
                                        >
                                                {item.name}
                                        </span>)
                                    })}
                            
                        </div>
                        
                    </div>
                    <div className={productCategoryStyle}>
                        <div className='w-full flex flex-row justify-between '>
                            <span className={productCategoryTextStyle} 
                            onClick={()=>{
                                navigate('/products/blinds')
                                closeAllDropDown()
                                }}>
                                Blinds
                            </span>
                            <div 
                                    className='flex justify-center items-center rounded-md' 
                                    
                                    onClick={()=>{
                                    setBlindDropDown(!blindDropDown)
                            }}>
                                    {(blindDropDown)&&<UpOutlined style={{ fontSize: '20px'}}/>}
                                    {!(blindDropDown)&&<DownOutlined style={{ fontSize: '20px'}}/>}
                            
                            </div>
                        </div>
                        
                        <div className={`mt-2 w-full flex flex-col gap-3 max-w-screen-2xl m-auto transition-height overflow-hidden ${blindDropDown ? 'h-[16em]' : 'h-0'} transition-all duration-500 ease-in-out pl-3`}>
                        
                            {Blinds.map((item,index)=>{
                                        return(<span key={index} className={choicesStyle}
                                            onClick={()=>{navigate(item.page)}}
                                        >
                                                {item.name}
                                        </span>)
                                    })}
                        </div>
                        
                    </div>
                    <div className={productCategoryStyle}>
                        <div className='w-full flex flex-row justify-between '>
                            <span className={productCategoryTextStyle}
                                 onClick={()=>{navigate('/products/curtains'); closeAllDropDown()}}
                            >
                                Curtains
                            </span>
                            <div 
                                    className='flex justify-center items-center rounded-md ' 
                                    
                                    onClick={()=>{
                                    setCurtainDropDown(!curtainDropDown)
                            }}>
                                    {(curtainDropDown)&&<UpOutlined style={{ fontSize: '20px'}}/>}
                                    {!(curtainDropDown)&&<DownOutlined style={{ fontSize: '20px'}}/>}
                            
                            </div>
                        </div>
                        
                        <div className={`mt-2 w-full flex flex-col gap-3 max-w-screen-2xl m-auto transition-height overflow-hidden ${curtainDropDown ? 'h-[5em]' : 'h-0'} transition-all duration-500 ease-in-out pl-3`}>
                        
                            {Curtains.map((item,index)=>{
                                        return(<span key={index} className={choicesStyle}
                                            onClick={()=>{navigate(item.page)}}
                                        >
                                                {item.name}
                                        </span>)
                                    })}
                        </div>
                        
                    </div>
                    <div className={productCategoryStyle}>
                        <div className='w-full flex flex-row justify-between '>
                            <span className={productCategoryTextStyle}
                             onClick={()=>{
                                navigate('/products/plantations')
                                closeAllDropDown()
                                }}
                            >
                                Plantation Shutters
                            </span>
                            <div 
                                    className='flex justify-center items-center rounded-md' 
                                    
                                    onClick={()=>{
                                    setPShutterDropDown(!PShutterDropDown)
                            }}>
                                    {(PShutterDropDown)&&<UpOutlined style={{ fontSize: '20px'}}/>}
                                    {!(PShutterDropDown)&&<DownOutlined style={{ fontSize: '20px'}}/>}
                            
                            </div>
                        </div>
                        
                        <div className={`mt-2 w-full flex flex-col gap-3 max-w-screen-2xl m-auto transition-height overflow-hidden ${PShutterDropDown ? 'h-[7em]' : 'h-0'} transition-all duration-500 ease-in-out pl-3`}>
                        
                        {Plantations.map((item,index)=>{
                                        return(<span key={index} className={choicesStyle}
                                            onClick={()=>{navigate(item.page)}}
                                        >
                                                {item.name}
                                        </span>)
                                    })}
                        </div>
                    </div>
                    <div className={productCategoryStyle +`mb-5`}>
                        <div className='w-full flex flex-row justify-between '>
                            <span className={productCategoryTextStyle} 
                            onClick={()=>{
                                navigate('/products/roller-shutters')
                                closeAllDropDown()
                                }}>
                                Roller Shutters
                            </span>
                            <div 
                                    className='flex justify-center items-center rounded-md' 
                                    
                                    onClick={()=>{
                                    setRShutterDropDown(!RShutterDropDown)
                            }}>
                                    {(RShutterDropDown)&&<UpOutlined style={{ fontSize: '20px'}}/>}
                                    {!(RShutterDropDown)&&<DownOutlined style={{ fontSize: '20px'}}/>}
                            
                            </div>
                        </div>
                        
                        <div className={`mt-2 w-full flex flex-col gap-3 max-w-screen-2xl m-auto transition-height overflow-hidden ${RShutterDropDown ? 'h-[12em]' : 'h-0'} transition-all duration-500 ease-in-out pl-3`}>
                        
                            {RollerShutters.map((item,index)=>{
                                        return(<span key={index} className={choicesStyle}
                                            onClick={()=>{navigate(item.page)}}
                                        >
                                                {item.name}
                                        </span>)
                                    })}
                        </div>
                        
                    </div>

                  
                    <div className={userDropdownStyle + `${(currUser==undefined)?'hidden':''} `}>
                        <div className='w-full flex flex-row justify-between '>
                            <span className={productCategoryTextStyle} 
                            onClick={()=>{
                                navigate('/order')
                                closeAllDropDown()
                                }}>
                                Order List
                            </span>
                            
                        </div>
                    </div>
                    <div className={userDropdownStyle + `${get_menu_horizontal()?'hidden':''}`}>
                        <div className='w-full flex flex-row justify-between '>
                            <span className={productCategoryTextStyle} 
                            onClick={()=>{
                                navigate('/user')
                                closeAllDropDown()
                                }}>
                                User Management
                            </span>
                            
                        </div>
                    </div>
                    <div className={userDropdownStyle + `${get_menu_horizontal()?'hidden':''}`}>
                        <div className='w-full flex flex-row justify-between '>
                            <span className={productCategoryTextStyle} 
                            onClick={()=>{
                                navigate('/price_management')
                                closeAllDropDown()
                                }}>
                                Price Management
                            </span>
                            
                        </div>
                    </div>
                    <div className={userDropdownStyle + `${(currUser==undefined)?'hidden':''}`}>
                        <div className='w-full flex flex-row justify-between '>
                            <span className={productCategoryTextStyle} 
                            onClick={()=>{
                                navigate(`/user/${currUser?.user_id}`)
                                closeAllDropDown()
                                }}>
                                My Details
                            </span>
                            
                        </div>
                    </div>
                    <div className={userDropdownStyle + `${(currUser==undefined)?'hidden':''}`}>
                        <div className='w-full flex flex-row justify-between '>
                            <span className={productCategoryTextStyle} 
                            onClick={()=>{
                                logout(); window.location.reload();
                                closeAllDropDown()
                                }}>
                                Log Out
                            </span>
                            
                        </div>
                    </div>
                    <div className={userDropdownStyle + `${(currUser==undefined)?'':'hidden'}`}>
                        <div className='w-full flex flex-row justify-between '>
                            <span className={productCategoryTextStyle} 
                            onClick={()=>{
                                setOnLoginModal()
                                closeAllDropDown()
                                }}>
                                Log In
                            </span>
                            
                        </div>
                    </div>
                    
                    
                </div>
        </div>
    )
}
